import { isPublicListingRuntimePath } from "@/lib/listings/navigation";
import * as Sentry from "@sentry/astro";

import { sentryDsnWeb, sentryEnvironment, sentryRelease } from "./sentryUtils";

if (!isPublicListingRuntimePath(window.location.pathname)) {
  if (!sentryDsnWeb || !sentryEnvironment || !sentryRelease) {
    console.error("Sentry is not configured properly");
  }

  Sentry.init({
    dsn: sentryDsnWeb,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [/^\/(?!\/)/, import.meta.env.PUBLIC_BASE_URL, "127.0.0.1", "localhost"],
    tracesSampleRate: 1.0,
    // v10 gates user IP/geo inference behind this flag; keep it on to preserve
    // the per-user attribution we had implicitly in v9.
    sendDefaultPii: true,
    environment: sentryEnvironment,
    release: sentryRelease,
  });
}
